import React from 'react';
import '../scss/component/_section.scss';
import '../scss/component/_box.scss';
import '../scss/component/_tf-section.scss';
import '../scss/component/_reponsive.scss';
import Banner from '../components/banner/banner_v1';
import dataBanner from '../assets/fake-data/data-banner';
import Project2 from '../components/project/project_v2';
import dataSolution from '../assets/fake-data/data-solution';
import CTA3 from '../components/cta/CTA3';
import Step from '../components/Step/Step';
import dataStep from '../assets/fake-data/data-step';
import Partner4 from '../components/partner/Partner4';
import { dataClients } from '../assets/fake-data/data-partner';
import CTA from '../components/cta';
import Section from '../components/section';

const platform = {
    title: "Trabajo previo en Soluciones a Medida",
    description: [
        "Rubro: Minería, Transporte, Vehículos y Maquinaria Pesada, Industria, Seguridad Industrial, Operaciones, Mantenimiento Preventivo",
        "Soluciones en simuladores a medida y personalizados para empresas."
    ],
    photo: "https://www.youtube.com/watch?v=LFD83qrdmCI",
    type: "video",
    textPosition: "right",
}

function Home(props) {

    return (
        <div className='header-fixed main home1 home3 counter-scroll'>
            {<Banner data={dataBanner} />}
            {<Project2 className='mb-3 mt-3' data={dataSolution} />}
            {<CTA3 className='mb-3 mt-3' />}
            {<Step className='mb-5 mt-5' data={dataStep} />}
            {<Partner4 className='mt-5' data={dataClients} />}
            {<Section className='mb-3 mt-3' data={platform} />}
            <CTA />
        </div>
    );
}

export default Home;